import { FileReader, FileWriter } from '@/platform'
import UniteVar from './UniteVar'

class GameUniteVar {
    /// <summary>
    /// 整合变量组名
    /// </summary>
    public Name: string = ''

    /// <summary>
    /// 整合变量数据表
    /// </summary>
    public Data: Array<UniteVar> = []

    constructor(name: string = '') {
        this.Name = name
        for (let i = 0; i < 20; i++) {
            this.Data.push(new UniteVar())
        }
    }

    readBin(reader: FileReader): void {
        this.Name = reader.readString()
        this.Data = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let uv = new UniteVar()
            uv.readBin(reader)
            this.Data.push(uv)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var uv = this.Data[i]
            if (uv instanceof UniteVar === false) {
                uv = Object.assign(new UniteVar(), uv)
            }
            uv.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.Data = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let uv = new UniteVar()
            uv.readVersionedOui(reader.readObj(reader.readInt()))
            this.Data.push(uv)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)

        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var uv = this.Data[i]
            if (uv instanceof UniteVar === false) {
                uv = Object.assign(new UniteVar(), uv)
            }
            uv.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}
export default GameUniteVar
